<template>
  <!-- 账单明细 -->
  <div class="page-container" id="ebOrderContainer">
    <el-form :model="bcLedgerComp" ref="ruleFormRef" class="form-panel" label-position="top"
             :validateOnRuleChange="false">
     <!--  <el-col :span="24" > -->
        <!-- <div> -->

        <el-row class="content-panel top-radius">
                  <div>
<!--          <el-button type="primary" size="small" plain @click="">打印</el-button>-->
          <el-button type="primary" size="small" plain @click="billExport">账单导出</el-button>
        </div>
          <el-col style="height:12px;">
          </el-col>
          <el-col>
            <el-row :gutter="22">
              <el-col :span="5">
                <el-form-item label="账单号:">
                  <el-input size="mini" v-model="bcLedgerComp.compNo" readonly></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="5">
                <el-row>
                  <el-col :span="16">
                    <el-form-item label="总金额">
                      <el-input size="mini" v-model="bcLedgerComp.amount" readonly></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="8">
                    <el-form-item>
                      <label slot="label" class="label_no"></label>
                      <el-input size="mini" v-model="bcLedgerComp.currencyCode" readonly></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
              </el-col>
              <el-col :span="5">
                <el-form-item label="账单状态">
                  <el-input size="mini" v-model="bcLedgerComp.confirmStatus" readonly></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="9">
                <el-form-item label="备注">
                  <el-input size="mini" v-model="bcLedgerComp.remark" readonly></el-input>
                </el-form-item>
              </el-col>
            </el-row>
          </el-col>
          <el-col style="height:2px;">
          </el-col>
        </el-row>
        <!-- 表格-start -->
     <el-row class="table-panel">
        <el-row>
          <hot-table ref="ebOrderTableRef" :data-source="ebOrderTableDataSource"
                     :settings="ebOrderTableSettings" col-settings-key="ebOrder">
            <hot-column :has-tip="true" data="mblNo" title="提单号" width="150"></hot-column>
            <hot-column :has-tip="true" data="orderDate" title="订单日期"
                        date-format="YYYY-MM-DD HH:mm:ss" width="150"></hot-column>
            <hot-column :has-tip="true" data="custBizNo" title="客户业务编号" width="150"></hot-column>
            <hot-column :has-tip="true" data="invoiceCode" title="发票代码" width="150"></hot-column>
            <hot-column :has-tip="true" data="freightNameCn" title="费用名称" width="150"></hot-column>
            <hot-column :has-tip="true" data="settleCurrencyCode" title="币别" width="150"></hot-column>
            <hot-column :has-tip="true" data="unitPrice" title="单价" width="150"></hot-column>
            <hot-column :has-tip="true" data="quantity" title="数量" width="150"></hot-column>
            <hot-column :has-tip="true" data="settleAmount" title="金额" width="150"></hot-column>
            <hot-column :has-tip="true" data="confirmStatus" title="确认状态" width="150"></hot-column>
            <hot-column :has-tip="true" data="allocationStatus" title="支付状态" width="150"></hot-column>
            <hot-column :has-tip="true" data="creatorName" title="创建人" width="150"></hot-column>
            <hot-column :has-tip="true" data="createTime" title="创建时间"
                        date-format="YYYY-MM-DD HH:mm:ss" width="150"></hot-column>
            <hot-column :has-tip="true" data="businessName" title="业务对象" width="150"></hot-column>
          </hot-table>
        </el-row>
    <!--   </el-col> -->
      <!-- 分页start -->
      <div class="pg_div">
        <el-pagination :current-page="pageConfig.currentPage" :layout="pageConfig.layout"
                       :page-size="pageConfig.pageSize" :page-sizes="pageConfig.pageSizes" :total="pageConfig.total"
                       @current-change="handleCurrentChange" @size-change="handleSizeChange"/>
      </div>
  </el-row>
      <!-- 分页end -->
      <!-- 表格-end -->

    </el-form>
  </div>
</template>

<script>
import { queryCarrierInfo, queryVesselInfo } from "@/api/commonService";
import { queryBill } from "@/api/queryMainSystem";

export default {
  data() {
    return {
      //日期设置
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
        shortcuts: [{
          text: '今天',
          onClick(picker) {
            picker.$emit('pick', new Date());
          }
        }, {
          text: '昨天',
          onClick(picker) {
            const date = new Date();
            date.setTime(date.getTime() - 3600 * 1000 * 24);
            picker.$emit('pick', date);
          }
        }, {
          text: '一周前',
          onClick(picker) {
            const date = new Date();
            date.setTime(date.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit('pick', date);
          }
        }]
      },
      readonly: true,
      bcLedgerComp: {
        compNo: '',
        amount: '',
        currencyCode: '',
        confirmStatus: '',
        remark: '',

      },
      // 船公司联想控件
      associate_columns_carrier: [{
        title: "中文简称",
        field: 'custAlias'
      },
        {
          title: "中文全称",
          field: 'custNameCn'
        },
        {
          title: "助记码",
          field: 'mnemonicCode'
        }
      ],
      // 船名联想控件
      associate_columns_vessel: [{
        title: "中文名称",
        field: 'vesselNameEn'
      },
        {
          title: "英文名称",
          field: 'vesselNameCn'
        },
        {
          title: "助记码",
          field: 'mnemonicCode'
        }
      ],
      // 航次联想控件
      associate_columns_voyage: [{
        title: "航次",
        field: 'voyage'
      }],
      ebOrder: {
        orderNo: '',
        mblNo: '',
        hblNo: '',
        containerNo: '',
        transportType: '',
        shipper: '',
        consignee: '',
        pol: '',
        pod: '',
        OrderType: '',
      },
      mainOrder: {
        atdFrom: '',
        atdTo: '',
        ataFrom: '',
        ataTo: '',
        projectNo: '',
      },
      formData: {
        billNo: '',
        currency: '',
        mblNo: '',
        mcbNo: '',
        billStatus: '',
        carrierName: '',
        vesselName: '',
        voyage: '',
        sailingTimeFrom: '',
        sailingTimeTo: '',

      },

      // 分页
      pageConfig: {
        layout: 'total, sizes, prev, pager, next, jumper',
        total: 0,
        pageSize: 10,
        pagerCount: 10,
        currentPage: 1,
        pageSizes: [10, 20, 50, 100]
      },

      // 表格校验
      ebOrderRules: {},
      // 表格数据
      ebOrderTableDataSource: [],
      // 表格设置
      ebOrderTableSettings: {
        height: 360,
        stretchH: 'all', // 根据宽度横向扩展，last:只扩展最后一列，none：默认不扩展
        ...this.$systemConfig.tableConfig

      },

    };
  },
  async created() {

  },
  mounted() {
    let self = this
    if (self.$route.query.info) {
      self.bcLedgerComp = self.$route.query.info;
      self.getDetail(self.$route.query.info.bcLedgerCompId);
    }
    // 监听外层容器div宽度的变化，做表格自适应
    self.resizeObserver = new ResizeObserver(entries => {
      self.$nextTick(() => {
        self.$refs.ebOrderTableRef.resizeTo(entries[0].target.clientWidth - 32)
      })
    })
    self.resizeObserver.observe(document.getElementById("ebOrderContainer"))
  },
  methods: {
    getDetail(bcLedgerCompId) {
      let self = this;
      let searchData = {
        "isDetail": "Y",
        "bcLedgerCompId": bcLedgerCompId
      }
      searchData.currentPage = self.pageConfig.currentPage;
      searchData.pageSize = self.pageConfig.pageSize;
      queryBill(searchData).then((res) => {
        if (res.success) {
          self.ebOrderTableDataSource = res.records.records;
          self.pageConfig.total = res.records.totalRecord;
          self.$coreMethods.message("success", "查询成功");
        }
      });
    },
    // pageSize 改变时会触发
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
      this.pageConfig.pageSize = val;
      let self = this;
      self.queryStatusPage();
    },
    // currentPage 改变时会触发
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`)
      this.pageConfig.currentPage = val
    },
    //点击
    clickModule(e) {

    },
    //重置搜索框
    resetForm() {
      this.formData = {}
    },
    // 船公司联想控件数据源
    associate_queryMethod_carrier({ keyword, pageSize, currentPage }) {
      let params = {}
      if (keyword === '') {
        params = {
          custType4: "%SO%",
          isDeleted6: "0"
        }
      } else {
        params = {
          custAlias0: "%" + keyword + "%",
          custNameCn1: "%" + keyword + "%",
          custType4: "%SO%",
          isDeleted6: "0",
          mdmCustCode3: "%" + keyword + "%",
          mnemonicCode2: "%" + keyword + "%",
        }
      }

      let data =
          {
            action: "query",
            crudType: "SELECT",
            sorting: ["CTS_ILPCsCust.custNameCn"],
            mainModelName: "CTS_ILPCsCust",
            tag: "CTS_WEB_es",
            where: "(((((CTS_ILPCsCust.custAlias LIKE :custAlias0 OR CTS_ILPCsCust.custNameCn LIKE :custNameCn1) ) AND CTS_ILPCsCust.esCustType LIKE :custType4) ) AND CTS_ILPCsCust.isDeleted = :isDeleted6)",
            currentPage: currentPage,
            pageSize: pageSize,
            returnPage: true,
            returnTotal: false,
            reqArgs: params,
            fields: [
              "CTS_ILPCsCust.csCustId",
              "CTS_ILPCsCust.custAlias",
              "CTS_ILPCsCust.custNameCn",
              "CTS_ILPCsCust.custNameEn",
              "CTS_ILPCsCust.customsRegisteredNo",
              "CTS_ILPCsCust.esCustType",
              "CTS_ILPCsCust.isActive",
              "CTS_ILPCsCust.isBlacklist",
              "CTS_ILPCsCust.isCustomer",
              "CTS_ILPCsCust.isDeleted",
              "CTS_ILPCsCust.isOneTimeCustomer",
              "CTS_ILPCsCust.isSettlement",
              "CTS_ILPCsCust.isSupplier",
              "CTS_ILPCsCust.legalPerson",
              "CTS_ILPCsCust.mdmCustCode",
              "CTS_ILPCsCust.mobileNo",
              "CTS_ILPCsCust.postCode"
            ],
            enableCascade: true

          }
      return new Promise(resolve => {
        queryCarrierInfo(data).then(res => {
          console.log("queryCarrierInfo", res)
          resolve({
            records: res.data.data,
            total: res.data.totalRecord
          })
        })
      }).catch(err => {
        console.log(err)
      })
    },
    // 船名联想控件数据源
    associate_queryMethod_vessel({ keyword, pageSize, currentPage }) {
      let params = {}
      if (keyword === '') {
        params = {
          isDeleted3: "0"
        }
      } else {
        params = {
          vesselNameEn0: "%" + keyword + "%",
          vesselNameCn1: "%" + keyword + "%",
          mnemonicCode2: "%" + keyword + "%",
          isDeleted3: "0"
        }
      }

      let data = {
        action: "query",
        crudType: "SELECT",
        sorting: ["CTS_ILPMdVessel.vesselNameEn"],
        mainModelName: "CTS_ILPMdVessel",
        tag: "CTS_ILP_es",
        where: "(((CTS_ILPMdVessel.vesselNameEn LIKE :vesselNameEn0 OR CTS_ILPMdVessel.vesselNameCn LIKE :vesselNameCn1) OR CTS_ILPMdVessel.mnemonicCode LIKE :mnemonicCode2) AND CTS_ILPMdVessel.isDeleted = :isDeleted3)",
        currentPage: currentPage,
        pageSize: pageSize,
        returnPage: true,
        returnTotal: false,
        reqArgs: params,
        fields: ["CTS_ILPMdVessel.mdVesselId", "CTS_ILPMdVessel.vesselCarrierName",
          "CTS_ILPMdVessel.appCode", "CTS_ILPMdVessel.vesselType", "CTS_ILPMdVessel.unCode",
          "CTS_ILPMdVessel.creatorName", "CTS_ILPMdVessel.lastModifyOfficeName",
          "CTS_ILPMdVessel.lastModifyOffice", "CTS_ILPMdVessel.creatorId",
          "CTS_ILPMdVessel.vesselAttribute", "CTS_ILPMdVessel.vesselNameEn",
          "CTS_ILPMdVessel.principalGroupCode", "CTS_ILPMdVessel.callSign",
          "CTS_ILPMdVessel.recordVersion", "CTS_ILPMdVessel.isDeleted", "CTS_ILPMdVessel.createTime",
          "CTS_ILPMdVessel.lastModifierId", "CTS_ILPMdVessel.createOfficeName",
          "CTS_ILPMdVessel.vesselCarrierId", "CTS_ILPMdVessel.lastModifierName",
          "CTS_ILPMdVessel.vesselNameCn", "CTS_ILPMdVessel.imoNo", "CTS_ILPMdVessel.isActive",
          "CTS_ILPMdVessel.createOffice", "CTS_ILPMdVessel.mnemonicCode",
          "CTS_ILPMdVessel.customsVesselName", "CTS_ILPMdVessel.countryCode",
          "CTS_ILPMdVessel.countryNameCn", "CTS_ILPMdVessel.lastModifyTime"
        ],
        enableCascade: true
      }
      return new Promise(resolve => {
        queryVesselInfo(data).then(res => {
          console.log("res", res)
          resolve({
            records: res.data.data,
            total: parseInt(res.data.totalRecord)
          })
        })
      }).catch(err => {
        console.log(err)
      })
    },
    // 航次联想控件数据源
    associate_queryMethod_voyage({ keyword, pageSize, currentPage }) {

    },
  }
};
</script>

<style scoped lang="less">

</style>
